if (!customElements.get('cart-upsells-slider')) {
  class CartUpsellsSlider extends HTMLElement {
    constructor() {
      super();
      this.boundOnSliderNavClick = this.onSliderNavClick.bind(this);
    }

    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        this.onCartUpdate();
      });
      this.addEventListener('click', this.boundOnSliderNavClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundOnSliderNavClick);
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    onSliderNavClick(event) {
      if (!this.closest('cart-notification')) return;
      const prevBtn = event.target.closest('[data-vf-slider-prev]');
      const nextBtn = event.target.closest('[data-vf-slider-next]');
      let gtmEvent = null;
      if (prevBtn) gtmEvent = 'upsell_add_to_cart_arrow_left';
      else if (nextBtn) gtmEvent = 'upsell_add_to_cart_arrow_right';
      if (gtmEvent && typeof window.pushToDataLayer === 'function') {
        window.pushToDataLayer({ event: gtmEvent });
      }
    }

    onCartUpdate() {
      fetch(`${routes.cart_url}?section_id=cart-upsells-slider`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.innerHTML = html.querySelector('#cart-upsells-slider').innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('cart-upsells-slider', CartUpsellsSlider);
}